import { useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SyncLoader } from "react-spinners";

import {
  socketService,
  SOCKET_EMIT_SET_TOPIC,
  SOCKET_EVENT_ADD_UPDATE_BOARD,
} from "../services/socket.service";
import {
  loadBoard,
  loadBoards,
  loadSocketBoard,
  setFilter,
  loadCurrentBoard
} from "../store/board.actions";
import { GeneralQueryActions, loadGroupsWithActivities,loadGroupsWithUsuarios,loadGroupsWithProyectos,getProyectosall } from "../store/grupo.actions";
import { CargarUsers } from "../store/user.actions";
import { CargarInfoModulos } from "../store/grupo.actions";

import { userService } from '../services/user.service';

import { ModalMemberInvite } from "../cmps/modal/modal-member-invite";
import { WorkspaceSidebar } from "../cmps/sidebar/workspace-sidebar";
import { LoginLogoutModal } from "../cmps/modal/login-logout-modal";
import { GroupListKanban } from "../cmps/kanban/group-list-kanban";
import { BoardDescription } from "../cmps/board/board-description";
import { MainSidebar } from "../cmps/sidebar/main-sidebar";
import { DynamicModal } from "../cmps/modal/dynamic-modal";
import { boardService } from "../services/board.service";
import { CreateBoard } from "../cmps/modal/create-board";
import { BoardHeader } from "../cmps/board/board-header";
import { BoardModal } from "../cmps/board/board-modal";
import { GroupList } from "../cmps/board/group-list";
import { loadUsers } from "../store/user.actions";
import { Loader } from "../cmps/loader";
import { Dashboard } from "./dashboard";
import { Container } from "@mui/material";
import { Link, useNavigate } from 'react-router-dom'
import { ROLES } from '../services/user.service'; // Asegúrate de importar correctamente


export function BoardDetails() {
  const board = {
    _id: "65f794584accc238e4667b5d",
    title: "midterm",
    archivedAt: 1710724179497,
    isStarred: false,
    createdBy: {
      fullname: "Ofer Gavrilov",
      imgUrl:
        "https://res.cloudinary.com/du63kkxhl/image/upload/v1674069496/me_dpbzfs.jpg",
      _id: "nevAzC",
    },
    labels: [
      {
        id: "no_iniciada",
        title: "No iniciada",
        color: "#bb3354",
      },
      {
        id: "en_proceso",
        title: "En proceso",
        color: "#ff642e",
      },
      {
        id: "terminada",
        title: "Terminada",
        color: "#027e4c",
      },
      {
        id: "no_se_realizara",
        title: "No se realizará",
        color: "#7e5346",
      },
    ],
    members: [
      {
        _id: "65abe7479f4b535e24f37733",
        username: "Matheus20",
        fullname: "Matheus Henrique Maas",
        imgUrl: null,
        createdAt: "2024-01-20T15:31:19.000Z",
      },
    ],
    groups: [
      {
        title: "GRUPO DE PRUEBA",
        archivedAt: 1712677421005,

        tasks: [
          {
            title: "ssdfjlsjflsf\n\n",
            status: "en_proceso",
            priority: "",
            memberIds: [],
            dueDate: "",
            comments: [],
            updatedBy: {
              imgUrl:
                "https://res.cloudinary.com/du63kkxhl/image/upload/v1675013009/guest_f8d60j.png",
              date: 1713276413640,
            },
            file: "",
            id: "BvQMag",
            subitems: [
              {
                title: "SubItem 1\n\n",
                status: "en_proceso",
                priority: "",
                memberIds: [],
                dueDate: "",
                comments: [],
                updatedBy: {
                  imgUrl:
                    "https://res.cloudinary.com/du63kkxhl/image/upload/v1675013009/guest_f8d60j.png",
                  date: 1713276413640,
                },
                file: "",
                id: "BvQMag",
              },
              {
                title: "SubItem 2\n\n",
                status: "en_proceso",
                priority: "",
                memberIds: [],
                dueDate: "",
                comments: [],
                updatedBy: {
                  imgUrl:
                    "https://res.cloudinary.com/du63kkxhl/image/upload/v1675013009/guest_f8d60j.png",
                  date: 1713276413640,
                },
                file: "",
                id: "BvQMag",
              },
            ],
          },
        ],
        color: "#579bfc",
        id: "CqMJhj",
      },
    ],
    activities: [
      {
        action: "status",
        createdAt: 1713288519806,
        byMember: {
          _id: null,
          fullname: "Guest",
          imgUrl:
            "https://res.cloudinary.com/du63kkxhl/image/upload/v1675013009/guest_f8d60j.png",
        },
        task: {
          id: "rmaTT7",
          title: "ssaasd",
        },
        from: {
          id: "en_proceso",
          title: "En Proceso",
          color: "#a25ddc",
        },
        to: {
          id: "terminada",
          title: "Terminada",
          color: "#00c875",
        },
      },
    ],
    // cmpsOrder: ["status-picker","status-picker", "date-picker", "file-picker", "number-picker"],
    cmpsOrder: ["number-picker","number-picker2","progress-picker"],
    description: "",
    cmpsOption: [
      "status-picker",
      "member-picker",
      "date-picker",
      "priority-picker",
      "number-picker",
      "file-picker",
      "updated-picker",
    ],
  };

  const usuarios = useSelector( (storeState) => storeState.userModule.users );
  const grupos = useSelector( (storeState) => storeState.grupoModule.grupos );
  const boards = useSelector( (storeState) => storeState.boardModule.boards );
  const currentBoard = useSelector( (storeState) => storeState.boardModule.currentBoard );
  const DataModulo = useSelector(storeState => storeState.infoModulo.infoM)

  const mainIsLoading = useSelector( (storeState) => storeState.grupoModule.isLoading );
  const mainIsEmpty = useSelector( (storeState) => storeState.grupoModule.isEmpty );
  
  const isBoardModalOpen = useSelector(
    (storeState) => storeState.boardModule.isBoardModalOpen
  );

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [customHeight, setCustomHeight] = useState(140);

  const [isShowDescription, setIsShowDescription] = useState(false);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isStarredOpen, setIsStarredOpen] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const [boardType, setBoardType] = useState("table");

  const [isWorkspaceOpen, setIsWorkspaceOpen] = useState(false);
  const [workspaceDisplay, setWorkspaceDisplay] = useState("board");
  const [user, setUser] = useState(userService.getLoggedinUser().data.data);
  const members = useSelector(storeState => storeState.userModule.users);
  const navigate = useNavigate();

  const { boardId } = useParams();
  const [selectedProject, setSelectedProject] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const queryFilterBy = boardService.getFilterFromSearchParams(searchParams);
  const isEditable = user?.rol === ROLES.ADMIN || user?.rol === ROLES.AUDITOR;
  //Tecnicos 
  const UsuariosT = 'grupos/getGruposWithUsuarios'; 
  const parametrosT = {idTablero: boardId, idUsuario: user.id_usuario };

  //Administracion
  const UsuariosA = 'grupos/actividades';
  const parametrosA = {idTablero: boardId };

  const [isLoading, setIsLoading] = useState(true);

  




  const usuariosAdmin = [1, 2,7,20];

  useEffect(() => {
    // Cargar el board actual de manera asíncrona
    LoginBoardInfo(boardId);

    // Verificación del usuario y llamado a `GeneralQueryActions` según si es editable
    if (user) {
        const queryAction = isEditable ? UsuariosA : UsuariosT;
        const parametros = isEditable ? parametrosA : parametrosT;
        GeneralQueryActions(queryAction, parametros);
    } else {
        // Navegar o hacer cualquier otra acción cuando no hay usuario
        // navigate(`/`); // O cualquier otra acción relevante
    }

}, [boardId, user, isEditable]); // Dependencias actualizadas

  // useEffect(() => {
  //     socketService.emit(SOCKET_EMIT_SET_TOPIC, boardId)
  //     socketService.on(SOCKET_EVENT_ADD_UPDATE_BOARD, loadSocketBoard)

  //     return () => {
  //         socketService.off(SOCKET_EVENT_ADD_UPDATE_BOARD, loadSocketBoard)
  //     }
  // }, [])

  // useEffect(() => {
  //     socketService.off(SOCKET_EVENT_ADD_UPDATE_BOARD, loadSocketBoard)
  //     socketService.emit(SOCKET_EMIT_SET_TOPIC, boardId)
  //     socketService.on(SOCKET_EVENT_ADD_UPDATE_BOARD, loadSocketBoard)
  // }, [boardId, isBoardModalOpen])

  function onSetFilter(filterBy) {
    setSearchParams(filterBy);
    loadBoard(boardId, filterBy);
    setFilter(filterBy);
  }
  

async function LoginBoardInfo(boardId) {
  try {
   
       
          const board = await loadCurrentBoard(boardId); 

              // Validar si members está vacío
            if (members.length === 0) {
              CargarUsers(board.fk_region_id); // Llama a la función para cargar los usuarios
            } 

            if(DataModulo.length ===0||DataModulo === undefined){
              CargarInfoModulos(board.fk_region_id);
            }
        
        
       

  } catch (error) {
      console.error('Error loading board:', error); // Manejo de errores
  }
}
  

const handleProjectSelect = (project) => {
  setSelectedProject(project);
  getProyect(project);
};


function getProyect(idproyecto) {
  let endpoint = '';
  let params = {};

  if (idproyecto) {
      endpoint = isEditable ? 'grupos/getProyectosAll' : 'grupos/actividadesForProyec';
      params = isEditable
          ? { idTablero: boardId, idProyecto: idproyecto }
          : { idTablero: boardId, idUsuario: user.id_usuario, idProyecto: idproyecto };
  } else {
      endpoint = isEditable ? UsuariosA : UsuariosT;
      params = isEditable ? parametrosA : parametrosT;
  }
  
  GeneralQueryActions(endpoint, params);
}


  return (
    <section className="board-details flex">
      <div className="sidebar flex">
        <MainSidebar
          setWorkspaceDisplay={setWorkspaceDisplay}
          setIsWorkspaceOpen={setIsWorkspaceOpen}
          setIsLoginModalOpen={setIsLoginModalOpen}
        />
        <WorkspaceSidebar
          workspaceDisplay={workspaceDisplay}
          isWorkspaceOpen={isWorkspaceOpen}
          setIsWorkspaceOpen={setIsWorkspaceOpen}
          board={board}
          setIsCreateModalOpen={setIsCreateModalOpen}
          onProjectSelect={handleProjectSelect}
        />
      </div>

      <main className="board-main">
        <BoardHeader
          customHeight={customHeight}
          setCustomHeight={setCustomHeight}
          currentBoard = {currentBoard}
          boardType={boardType}
          setBoardType={setBoardType}
          board={board}
          onSetFilter={onSetFilter}
          isStarredOpen={isStarredOpen}
          setIsShowDescription={setIsShowDescription}
          setIsInviteModalOpen={setIsInviteModalOpen}
        />

        {
          boardType === "table" && (
            mainIsLoading ? (
              <div style={{ marginTop: "10rem", display: 'flex', justifyContent: "center" }}>
                <SyncLoader color="#01a5d2" size={20} />
                
              </div>
            ) : (
              mainIsEmpty ? (
                <div style={{ marginTop: "10rem", display: 'flex', justifyContent: "center" }}>
                  ¡No se han encontrado datos!
                </div>
              ) : (
                <GroupList customHeight={customHeight} board={board} groups={grupos} users={usuarios} />
                
              )
            )
          )
        }

        {boardType === "kanban" && <GroupListKanban board={board} />}
        <BoardModal setIsMouseOver={setIsMouseOver} />
        {boardType === "dashboard" && <Dashboard />}
      </main>

      {isCreateModalOpen && (
        <CreateBoard setIsModalOpen={setIsCreateModalOpen} />
      )}
      {(isInviteModalOpen ||
        isCreateModalOpen ||
        (isBoardModalOpen && isMouseOver)) && (
        <div className="dark-screen"></div>
      )}
      {isShowDescription && (
        <>
          <BoardDescription
            setIsShowDescription={setIsShowDescription}
            board={board}
          />
          <div className="dark-screen"></div>
        </>
      )}
      {isLoginModalOpen && (
        <LoginLogoutModal setIsLoginModalOpen={setIsLoginModalOpen} />
      )}
      {isInviteModalOpen && (
        <ModalMemberInvite
          board={board}
          setIsInviteModalOpen={setIsInviteModalOpen}
        />
      )}
      <DynamicModal />
    </section>
  );
}
